<template>
  <div class="content my-info-frame">
    <div class="my-info-name">
      <div class="my-info-image">
        <i><img :src="vipInfo.currentVipImage" alt=""></i>
      </div>
      <div class="my-info-text">
        <span v-if="user.language === 'jp'" class="D-none">
          {{ $t("Bao.welcome_you") }}、{{ memberInfo.nickname }}{{ $t("Bao.expect") }}</span>
        <span v-else class="D-none">
          {{ $t("Bao.welcome_you") }}, {{ $t("Bao.expect") }} {{ memberInfo.nickname }}</span>
        <span>{{ vipInfo.currentVipName }}</span>
        <span v-if="vipInfo.last_update_date !== 0">
          {{ $t('Bao.last_update_date') }}: {{ last_update_date }}
        </span>
      </div>
    </div>
    <div class="my-lv-frame">
      <div class="keepvip_title">
        {{ $t('Bao.upgrade_require') }}
      </div>
      <ul class="my-lv">
        <li>
          <template v-if="vipInfo.upgradeNeedDepositAmount !== 0">
            <div class="my-turnover">
              <div><span>{{ $t('Bao.accumulate_deposit') }}</span></div>
              <div class="percent">
                <div
                  class="percent-current"
                  :style="{ 'width': upgrade_deposit_amount_percentage + '%' }"
                />
              </div>
              <div :class="upgradeDepositAmountClass" />
              <div class="shortOf">
                <span>{{ $t('Bao.short_of') }}</span><span> {{ deposit_amount }}</span>
              </div>
            </div>
          </template>
          <template v-if="vipInfo.upgradeNeedPerformance !== 0">
            <div class="my-turnover">
              <div><span>{{ $t('Bao.accumulate_turnover') }}</span></div>
              <div class="percent">
                <div
                  class="percent-current"
                  :style="{ 'width': upgrade_performance_percentage + '%' }"
                />
              </div>
              <div :class="performanceClass" />
              <div class="shortOf">
                <span>{{ $t('Bao.short_of') }}</span><span> {{ cumulative_flow }}</span>
              </div>
            </div>
          </template>
        </li>
      </ul>
    </div>
    <div v-if="false" class="personal-contaoner">
      <div class="personal_keepvip">
        <div class="keepvip_title">
          {{ $t('Bao.keep_your_VIP') }}
        </div>

        <div class="keepvip_area">
          <div class="personal_vip_detail">
            <div class="pvd-container">
              <div class="mb-10 title">
                {{ $t('Bao.deposit_amount_full') }}
              </div>
              <span class="mb-0 value">
                <b>
                  {{ keep_deposit }}
                </b>
              </span>
            </div>
            <span :class="depositAmountClass" />
          </div>

          <div class="personal_vip_detail">
            <div class="pvd-container">
              <div class="mb-10 title">
                {{ $t('Bao.cumulative_flow') }}
              </div>
              <span class="mb-0 value">
                <b>
                  {{ keep_bet_amount }}
                </b>
              </span>
            </div>
            <span :class="detailClass" />
          </div>
        </div>
      </div>
    </div>

    <section class="my-section-frame">
      <div class="h5 fs-14px">
        {{ $t('Bao.personal_data') }}
      </div>
      <div class="my-money my-wallet-frame">
        <div class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title">
              <div class="fs-6 fw-700">
                {{ $t('Bao.common_wallet') }}{{ $t('Bao.balance') }}
              </div>
              <div class="icon-refresh" @click="refreshGold('multi_wallet')">
                <img v-if="goldInfo" class="refresh" :src="$getThemeImagePath('icon-refresh.png')" alt="refresh gold">
                <i v-else class="fa fa-spinner fa-pulse fa-fw" />
              </div>
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx">
                <div class="con-left">
                  <div class="icon-coin">
                    <img :src="getWalletImagePath(app.selectedWallet)" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl tx-highlight">{{ getWalletBalance(app.selectedWallet) }}</span>
                </div>
                <div class="con-right">
                  <a class="detailed goTo-fun-detailed tx-highlight" @click.prevent="showWallet = true">
                    {{ $t('Bao.personal_detail') }}
                  </a>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="text-align-R wallet-tx-xl ">
                    {{ $t('Bao.available_withdrawal_amount') }}
                  </span>
                </div>
                <div class="con-right">
                  <span class="t-highlight fs-14px tx-highlight">
                    {{ displayAvailPrice }}
                  </span>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="text-align-R fs-14px">{{ $t('Bao.deposit_limit') }}</span>
                </div>
                <div class="con-right">
                  <span class="t-highlight fs-14px tx-highlight">{{ withdrawalLimit }}</span>
                </div>
              </li>
            </ul>

            <div class="my-wallet-BTN">
              <button class="btn-stroke" @click="$router.push('/deposit')">
                {{ $t('Bao.deposit') }}
              </button>
              <button class="btn-stroke" @click="$router.push('/withdrawal')">
                {{ $t('Bao.withdrawal') }}
              </button>
            </div>
          </div>
        </div>

        <div class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title fs-6 fw-700">
              {{ $t('Bao.bonus_gold') }}
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx bg-color">
                <div class="con-left">
                  <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
                </div>

                <div class="con-right">
                  <div class="icon-coin">
                    <img :src="$getThemeImagePath('icon_bonus.svg')" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl t-highlight tx-highlight">{{ user.bonusGold | numberFormat }}</span>
                </div>
              </li>

              <li class="wallet-items">
                <div class="con-left">
                  <span class="align-center">
                    {{ $t('Bao.deposit_limit') }}
                    <i class="icon-infor" @click="showModel(permissionInfo.bonus_wallet_rule)">
                      <img :src="$getThemeImagePath('icon_uestion.svg')" alt="">
                    </i>
                  </span>
                </div>

                <div class="con-right">
                  <span class="text-align-R balance fs-14px tx-highlight">{{ bonus_transfer_limit | numberFormat }}</span>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <div v-if="!isThemePurple" class="my-wallet">
          <div class="wallwt-container">
            <div class="my-info-card-title fs-6 fw-700">
              {{ $t('Bao.commission_gold') }}
            </div>
            <hr>
            <ul class="wallet-content">
              <li class="wallet-items wallet-tx bg-color">
                <div class="con-left">
                  <span class="wallet-tx-xl">{{ $t('Bao.balance') }}</span>
                </div>

                <div class="con-right">
                  <div class="icon-coin">
                    <img :src="$getThemeImagePath('icon_jpy.svg')" alt="">
                  </div>
                  <span class="text-align-R wallet-tx-xl t-highlight tx-highlight">
                    {{ user.commissionGold | numberFormat }}
                  </span>
                </div>
              </li>
            </ul>
            <div class="my-wallet-BTN">
              <button class="btn-stroke btn-transfer" @click="showTransferModal">
                {{ $t('Bao.transfer') }}
              </button>
              <button class="btn-stroke" @click="goWithdrawal">
                {{ $t('Bao.withdrawal') }}
              </button>
            </div>
          </div>
        </div>

        <div class="personal_area_txbox">
          <ol class="state_txbox">
            <li>{{ $t('Bao.cumulative_valid_wagers_principal_2') }}</li>
            <li>{{ $t('Bao.cumulative_valid_wagers_principal_3') }}</li>
          </ol>
        </div>

        <performance-modal :is-active="showModal" :limit-text="limitText" @hideModel="hideModel" />
        <transfer-modal
          :is-active="showTransfer"
          :trading-balance=" user.commissionGold"
          @hideTransferModal="hideTransferModal"
        />
      </div>
    </section>
    <personal-wallet-modal
      :is-active="showWallet"
      :avail-price="displayAvailPrice"
      :withdrawal-limit="withdrawalLimit"
      @hideWalletModal="hideWalletModal"
    />
  </div>
</template>

<script>
import { showNotice, refreshGold, getWalletImagePath, getWalletBalance } from '@/utils/tool'
import { withdrawalWallet } from '@/api/payment'
import performanceModal from '@/components/modal/performanceModal'
import transferModal from '@/components/modal/transferModal'
import { mapGetters } from 'vuex'
import PersonalWalletModal from '@/components/modal/personalWalletModal'

export default {
  components: {
    performanceModal,
    transferModal,
    PersonalWalletModal
  },
  data() {
    return {
      showModal: false,
      showTransfer: false,
      showWallet: false,
      limitText: '',
      detailClass: '',
      performanceClass: '',
      depositAmountClass: '',
      upgradeDepositAmountClass: '',
      wallets: []
    }
  },
  computed: {
    ...mapGetters(['user', 'memberInfo', 'brand', 'permissionInfo', 'goldLoading', 'goldInfo', 'mainGold', 'bonusGold', 'point', 'app', 'currentTheme']),
    vipInfo() {
      return this.user.vipInfo
    },
    currency() {
      return this.brand.currency
    },
    last_update_date() {
      const last_update_time = this.vipInfo.last_upgrade_time
      return last_update_time === 0 ? 0 : this.$options.filters.dateFormat(last_update_time)
    },
    upgrade_deposit_amount_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentDepositAmount) / parseInt(this.vipInfo.upgradeNeedDepositAmount) * 100
      return percentage > 100 ? 100 : percentage
    },
    upgrade_performance_percentage() {
      const percentage = parseInt(this.vipInfo.upgradeCurrentPerformance) / parseInt(this.vipInfo.upgradeNeedPerformance) * 100
      return percentage > 100 ? 100 : percentage
    },
    withdrawalLimit() {
      const wallet = this.app.selectedWallet
      if (wallet && wallet.withdrawal_limit) {
        const limit = parseFloat(wallet.withdrawal_limit) - parseFloat(wallet.turnover)
        return limit > 0 ? limit.toFixed(6) : '0'
      }

      return '0'
    },
    bonus_transfer_limit() {
      const limit = parseFloat(this.memberInfo.bonus_transfer_limit) - parseFloat(this.memberInfo.bonus_turnover)
      return limit > 0 ? limit : 0
    },
    deposit_amount() {
      const amount = this.vipInfo.upgradeNeedDepositAmount - this.vipInfo.upgradeCurrentDepositAmount
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    cumulative_flow() {
      const amount = this.vipInfo.upgradeNeedPerformance - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return 0
      }
    },
    keep_deposit() {
      const amount = this.vipInfo.keep_deposit - this.vipInfo.upgradeCurrentDepositAmount
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return this.$t('Bao.user_complete')
      }
    },
    keep_bet_amount() {
      const amount = this.vipInfo.keep_bet_amount - this.vipInfo.upgradeCurrentPerformance
      if (amount >= 0) {
        return this.$options.filters.numberFormat(amount)
      } else {
        return this.$t('Bao.user_complete')
      }
    },
    displayAvailPrice() {
      if (
        !this.user || this.user.mainGold === undefined || this.withdrawalLimit === undefined
      ) {
        return ''
      }

      const selectedWallet = this.app.selectedWallet
      if (!selectedWallet || Object.keys(selectedWallet).length === 0) {
        return '0'
      } else if (selectedWallet.wallet_type === 'main') {
        return this.$options.filters.numberFormat(this.user.mainGold)
      } else if (selectedWallet.amount_limit) {
        return this.$options.filters.numberFormat(selectedWallet.amount_limit.max)
      }

      return '0'
    },
    walletCurrency() {
      return this.$store.state.app.selectedWallet?.currency || ''
    },
    walletBalance() {
      return this.$store.state.app.selectedWallet?.balance || 0
    },
    isThemePurple() {
      return this.currentTheme === 'theme_purple'
    }
  },
  watch: {
    'app.selectedWallet': {
      immediate: true,
      handler(newWallet) {
        if (newWallet && newWallet.wallet_type) {
          const found = this.user.walletInfo.find(
            info => info.wallet_type === newWallet.wallet_type
          )
          if (found) {
            this.$set(this.app.selectedWallet, 'withdrawal_limit', found.withdrawal_limit)
            this.$set(this.app.selectedWallet, 'turnover', found.turnover)
          }

          if (this.wallets.length > 0) {
            const wallet = this.wallets.find(w => w.wallet_type === newWallet.wallet_type)
            if (wallet) {
              this.$set(this.app.selectedWallet, 'amount_limit', wallet.amount_limit)
            }
          }
        }
      }
    }
  },
  created() {
    withdrawalWallet().then((response) => {
      this.wallets = response.data.data
      if (this.wallets.length > 0) {
        const wallet = this.wallets.find(w => w.wallet_type === this.app.selectedWallet.wallet_type)
        if (wallet) {
          this.$set(this.app.selectedWallet, 'amount_limit', wallet.amount_limit)
        }
      }
    }).catch((error) => {
      console.log(error)
    })
  },
  mounted() {
    this.updateClasses()
  },
  methods: {
    refreshGold(position) {
      refreshGold(position)
    },
    showModel(text) {
      this.limitText = text
      this.showModal = true
    },
    showTransferModal() {
      showNotice(this.$t('Bao.transfer_notice_1') + '<br><br>' + this.$t('Bao.transfer_notice_2') + '<br>' + this.$t('Bao.transfer_notice_3'), () => {
        this.showTransfer = true
      })
    },
    hideModel() {
      this.showModal = false
    },
    hideTransferModal() {
      this.showTransfer = false
    },
    hideWalletModal() {
      this.showWallet = false
    },
    updateClasses() {
      this.upgradeDepositAmountClass = this.calculateClass(this.vipInfo.upgradeCurrentDepositAmount, this.vipInfo.upgradeNeedDepositAmount)
      this.performanceClass = this.calculateClass(this.vipInfo.upgradeCurrentPerformance, this.vipInfo.upgradeNeedPerformance)
      this.depositAmountClass = this.calculateClass(this.vipInfo.upgradeCurrentDepositAmount, this.vipInfo.keep_deposit)
      this.detailClass = this.calculateClass(this.vipInfo.upgradeCurrentPerformance, this.vipInfo.keep_bet_amount)
    },
    calculateClass(current, target) {
      const formattedCurrent = parseInt(current)
      const formattedTarget = parseInt(target)
      if (formattedCurrent === 0 && formattedTarget === 0) {
        return 'check-off'
      }
      return formattedCurrent >= formattedTarget ? 'check-on' : 'check-off'
    },
    getWalletImagePath,
    getWalletBalance,
    goWithdrawal() {
      localStorage.setItem('fromPersonalToWithdrawal', true)
      this.$router.push('/withdrawal')
    }
  }
}
</script>

